import React from 'react';
import styled from 'styled-components';

// Heading Components
export const H1 = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: ${props => props.theme.foreground};
  line-height: 1.2;
  margin: 0;
`;

export const H2 = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${props => props.theme.foreground};
  line-height: 1.3;
  margin: 0;
`;

export const H3 = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${props => props.theme.foreground};
  line-height: 1.4;
  margin: 0;
`;

export const H4 = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${props => props.theme.foreground};
  line-height: 1.4;
  margin: 0;
`;

export const H5 = styled.h5`
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.theme.foreground};
  line-height: 1.4;
  margin: 0;
`;

export const H6 = styled.h6`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${props => props.theme.foreground};
  line-height: 1.4;
  margin: 0;
`;

// Text Components
export const Text = styled.p`
  font-size: 1rem;
  color: ${props => props.theme.foreground};
  line-height: 1.5;
  margin: 0;
`;

export const TextSmall = styled.p`
  font-size: 0.875rem;
  color: ${props => props.theme.foreground};
  line-height: 1.5;
  margin: 0;
`;

export const TextXs = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.foreground};
  line-height: 1.5;
  margin: 0;
`;

export const TextMuted = styled.p`
  font-size: 1rem;
  color: ${props => props.theme.mutedForeground};
  line-height: 1.5;
  margin: 0;
`;

export const TextSmallMuted = styled.p`
  font-size: 0.875rem;
  color: ${props => props.theme.mutedForeground};
  line-height: 1.5;
  margin: 0;
`;

export const TextXsMuted = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.mutedForeground};
  line-height: 1.5;
  margin: 0;
`;

// Label Components
export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.theme.foreground};
  line-height: 1.4;
  margin: 0;
`;

export const LabelSmall = styled.label`
  font-size: 0.75rem;
  font-weight: 500;
  color: ${props => props.theme.foreground};
  line-height: 1.4;
  margin: 0;
`;

// Caption Components
export const Caption = styled.span`
  font-size: 0.75rem;
  color: ${props => props.theme.mutedForeground};
  line-height: 1.4;
  margin: 0;
`;

export const CaptionXs = styled.span`
  font-size: 0.625rem;
  color: ${props => props.theme.mutedForeground};
  line-height: 1.4;
  margin: 0;
`;

// Gradient Text Component
export const GradientText = styled.span`
  background: linear-gradient(90deg, hsl(104 98% 38%), hsl(88 100% 50%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;

// Link Component
export const Link = styled.a`
  color: ${props => props.theme.primary};
  text-decoration: none;
  transition: ${props => props.theme.transitionSmooth};
  
  &:hover {
    color: ${props => props.theme.primaryGlow || props.theme.primary};
    text-decoration: underline;
  }
`;

// Code Component
export const Code = styled.code`
  background: ${props => props.theme.muted};
  color: ${props => props.theme.foreground};
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: ${props => props.theme.fontMono};
`;

// Blockquote Component
export const Blockquote = styled.blockquote`
  border-left: 4px solid ${props => props.theme.primary};
  padding-left: 1rem;
  margin: 0;
  font-style: italic;
  color: ${props => props.theme.mutedForeground};
`; 